import React from "react";
import styles from "./ProfitDisplay.module.css";
import { useSelector } from "react-redux";
import dollarCoin from "../../images/dollarCoin.webp";

const ProfitDisplay = () => {
  const gameData = useSelector((state) => state.gameData);
  const gameSettings = useSelector((state) => state.gameSettings);
  return (
    <div className={styles.controlGroup}>
      <label className={styles.inputLabel}>
        {`Total Profit (${
          gameSettings.isInManualMode
            ? gameData.currentMultiplier
            : (gameData.winningAmount / gameSettings.betAmount).toFixed(3)
        }x)`}
      </label>
      <div className={styles.inputContainer}>
        <div className={styles.inputField}>
          {gameSettings.isInManualMode
            ? parseFloat(
                gameData.currentMultiplier * gameSettings.betAmount
              ).toFixed(3)
            : parseFloat(gameData.winningAmount).toFixed(3)}
        </div>
        <img src={dollarCoin} alt={dollarCoin} className={styles.dollarIcon} />
      </div>
    </div>
  );
};

export default ProfitDisplay;
